import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectPaintables } from '../_redux-photos';

const createPaintablesSelector = (photoId: string) =>
  createSelector(
    [(state: PhotoPrintsPdpState) => selectPaintables(state, photoId)],
    (paintables) => paintables
  );

export const useMemoizedPaintables = (photoId: string) => {
  const selector = useMemo(() => createPaintablesSelector(photoId), [photoId]);
  return useSelector(selector, shallowEqual);
};